import { useCallback, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

import { ISubjectContact } from "../../../HelpAndSupport/interfaces";

interface IInputs {
    name: string;
}

export default function useSubjectForm(
    onSubmit: (data: FormData) => Promise<void>,
    subject: ISubjectContact | undefined,
) {
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm<IInputs>({
        defaultValues: {
            name: subject?.name || '',
        },
        shouldFocusError: false,
    });

    const handleSubmitForm: SubmitHandler<IInputs> = async (data) => {
        setIsSubmiting(true);

        const formData = new FormData();

        if (data?.name) {
            formData.append('name', data.name);
        }

        await onSubmit(formData);

        setIsSubmiting(false);
    };

    const dummyRequest = useCallback(({ onSuccess }: any) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    }, []);

    return {
        handleSubmitForm,
        handleSubmit,
        control,
        isSubmiting,
        errors,
        dummyRequest,
    }
}